export const ADD_TO_FAVOURITES_REQUEST = 'ADD_TO_FAVOURITES_REQUEST';
export const ADD_TO_FAVOURITES_SUCCESS = 'ADD_TO_FAVOURITES_SUCCESS';
export const CLEAR_SELECTED_FAVOURITE_ID = 'CLEAR_SELECTED_FAVOURITE_ID';
export const DELETE_FAVOURITE_SUCCESS = 'DELETE_FAVOURITE_SUCCESS';
export const GET_FAVOURITES_SUCCESS = 'GET_FAVOURITES_SUCCESS';
